import React from 'react'
import { useAgTechAuthContext } from '@agtech/core/auth/AgTechAuthContext';
import { UserDataProvider } from '@agtech/data/users/AgTechUserQueries';
import AgTechClickableContainer from '../../../components/Buttons/AgTechClickableContainer';
import AgTechHeaderDetail, { AgTechHeaderDetailProps } from '../../../components/Headers/AgTechHeaderDetail';
import AgTechUserDetailPopup from '../popups/AgTechUserDetailPopup';
import { AgTechPopUpPosition } from '@agtech/core/functions/AgTechAppPopUps';

let AgTechHeaderUserDetail = (props: {
    classes?: string,
    settings?: AgTechHeaderDetailProps['settings']
}) => {
    const authContext = useAgTechAuthContext();
    const loggedInUser = authContext.user;
    const isSystemAdmin = loggedInUser?.role.findIndex(f => f === 'Admin') > -1;
    let userRole = 'User';

    if (isSystemAdmin) {
        userRole = 'Sys Admin';
    }
    else if (loggedInUser?.role.findIndex(f => f ==='OA') > -1) {
        userRole = 'Administrator';
    }

    return loggedInUser.id ? (
        <div className='tall column-based clickable centered min-w-[200px] px-2 color-changing hover:!text-highlight flex'>
            <UserDataProvider settings={{
                loading: {
                    showLoader: false
                },
                errorHandling: {
                    showFailure: false
                }
            }}>
                {(user) => (
                    <AgTechClickableContainer
                        classes={`tall column-based flex ${props.classes}`}
                        onClick={e => e.popups.showPopUp({
                            callerRef: e.clickableRef,
                            popup: () => <AgTechUserDetailPopup />,
                            config: {
                                position: AgTechPopUpPosition.BelowCentered
                            }
                        })}
                    >
                        <AgTechHeaderDetail
                            header={user.firstName + ' ' + user.lastName}
                            detail={user.userName}
                            settings={{
                                header: {
                                    classes: ['!text-base', props.settings?.header?.classes]
                                },
                                detail: {
                                    classes: ['!mt-[1px] text-xs', props.settings?.detail?.classes]
                                },
                                badge: {
                                    icon: 'fas fa-user-circle',
                                    classes: 'mr-4'
                                }
                            }}
                        />
                    </AgTechClickableContainer>
                    )}
            </UserDataProvider>
        </div>
    ) : null;
}

export default AgTechHeaderUserDetail;